import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].GET_REGULATIONS_APPLICATION_AREAS]: {
		url:'/company/:companyId/regulations/:regulationId/application_area/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].GET_REGULATIONS_APPLICATION_AREA]: {
		url: '/company/:companyId/regulations/:regulationId/application_area/:applicationAreaId/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].CREATE_REGULATIONS_APPLICATION_AREA]: {
		url:'/company/:companyId/regulations/:regulationId/application_area/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].PATCH_REGULATIONS_APPLICATION_AREA]: {
		url: '/company/:companyId/regulations/:regulationId/application_area/:applicationAreaId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].PUT_REGULATIONS_APPLICATION_AREA]: {
		url: '/company/:companyId/regulations/:regulationId/application_area/:applicationAreaId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_APPLICATION_AREA].DELETE_REGULATIONS_APPLICATION_AREA]: {
		url: '/company/:companyId/regulations/:regulationId/application_area/:applicationAreaId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}